import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Chargement…</div>;
  if (!user || !user.id) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}
